export { checkSignupStatus } from './anonymous-email';
